import React from "react";
import { PropTypes } from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Checkbox = props => {
  const faVal = props.value ? <FontAwesomeIcon icon="check" /> : "";

  return (
    <span className="fa-layers fa-fw" onClick={props.onClick}>
      {faVal}
      <FontAwesomeIcon icon={["far", "square"]} transform="shrink-2" />
    </span>
  );
};

Checkbox.propTypes = {
  value: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};

Checkbox.defaultProps = {
  value: false
};
export default Checkbox;
